import React, { useState } from 'react';
import { Heart, CheckCircle } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import { API } from '../App';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== password2) { setError('Passwörter stimmen nicht überein.'); return; }
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const text = await res.text();
      const data = JSON.parse(text);
      if (!res.ok) throw new Error(data.detail || 'Fehler');
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="login-page" data-testid="reset-password-page">
        <div className="login-card">
          <div className="login-header">
            <div className="login-icon"><Heart size={26} color="#fff" fill="#fff" /></div>
            <h3>Ungültiger Link</h3>
          </div>
          <div className="login-body">
            <div style={{ background: '#FEE2E2', color: '#991B1B', padding: '0.75rem 1rem', borderRadius: 10, marginBottom: '1rem', fontSize: 13 }}>
              Dieser Link ist ungültig oder abgelaufen.
            </div>
            <a href="/login" className="btn btn-primary btn-lg" style={{ display: 'block', textDecoration: 'none', textAlign: 'center' }}>
              Zurück zum Login
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page" data-testid="reset-password-page">
      <div className="login-card">
        <div className="login-header">
          <div className="login-icon"><Heart size={26} color="#fff" fill="#fff" /></div>
          <h3>Neues Passwort</h3>
          <p>{done ? 'Erfolgreich geändert' : 'Bitte legen Sie ein neues Passwort fest'}</p>
        </div>
        <div className="login-body">
          {done ? (
            <div>
              <div style={{ background: '#D1FAE5', color: '#065F46', padding: '0.75rem 1rem', borderRadius: 10, marginBottom: '1rem', fontSize: 13, display: 'flex', alignItems: 'center', gap: 8 }} data-testid="reset-success">
                <CheckCircle size={16} /> Ihr Passwort wurde erfolgreich geändert.
              </div>
              <a href="/login" className="btn btn-primary btn-lg" style={{ display: 'block', textDecoration: 'none', textAlign: 'center' }} data-testid="reset-to-login">
                Jetzt anmelden
              </a>
            </div>
          ) : (
            <>
              {error && (
                <div style={{ background: '#FEE2E2', color: '#991B1B', padding: '0.75rem 1rem', borderRadius: 10, marginBottom: '1rem', fontSize: 13 }} data-testid="reset-error">{error}</div>
              )}
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Neues Passwort</label>
                  <input className="form-input" type="password" placeholder="Min. 8 Zeichen" value={password} onChange={e => setPassword(e.target.value)} required data-testid="reset-password-input" />
                </div>
                <div className="form-group">
                  <label>Passwort wiederholen</label>
                  <input className="form-input" type="password" value={password2} onChange={e => setPassword2(e.target.value)} required data-testid="reset-password2-input" />
                </div>
                <button className="btn btn-primary btn-lg" type="submit" disabled={loading} data-testid="reset-submit-btn">
                  {loading ? 'Speichere...' : 'Passwort festlegen'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
      <div className="login-footer-text">BGPR Verwaltung &copy; 2026</div>
    </div>
  );
}
